import React from 'react';
import PropTypes from 'prop-types';
import { IconButton } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { icon } from '@fortawesome/fontawesome-svg-core/import.macro';
import { useHistory } from 'react-router-dom';

export const BackButton = ({ previousPage, ...rest }) => {
  const history = useHistory();
  const onClick = () => {
    if (!previousPage) {
      return;
    }
    history.push(previousPage);
  };
  return (
    <IconButton {...rest} onClick={onClick} color="inherit" style={{ zIndex: 10, width: '40px' }}>
      <FontAwesomeIcon icon={icon({ name: 'chevron-left' })} />
    </IconButton>
  );
};

BackButton.propTypes = {
  previousPage: PropTypes.string,
};

BackButton.defaultProps = {
  previousPage: undefined
};
